module.exports = __webpack_public_path__ + "static/media/PGL01@s.77dc3d55.jpg";